import React, { useState, useEffect } from "react";
import useForm from '../../../hooks/useForm'
import { FormField, Button, LoadingIcon } from '@prosolve/common-components-ui'
import { FaSave } from 'react-icons/fa';
import useDataSessionBlueprints from '../../../dataHooks/useDataSessionBlueprints';
import { useNavigate } from "react-router-dom";
import { checkHasEditEventTemplatePermissions } from '../../../utils';
import useSnackbar from "../../../hooks/useSnackbar";

export default () => {
  const snackbar = useSnackbar()

  const urlParams = new URLSearchParams(window.location.search);
  const moduleBlueprintId = urlParams.get('id');

  const isReadOnly = false;

  const {
    fetchModuleBlueprint,
    updateModuleBlueprint
  } = useDataSessionBlueprints();

  const formSchema = {
    requiredFields: ['name'],
    optionalFields: ['description', 'objective', 'image', 'blueprintDocumentLink', 'slideDeckLink'],
    initData: {}
  }

  const formData = useForm(formSchema)

  const [isSaving, setIsSaving] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const isValid = () => {
    if (formData.isValid()) {
      return true
    } else {
      return false
    }
  }

  const navigate = useNavigate();

  const getModuleBlueprint = async () => {
    setIsLoading(true);
    try {
      const mBlueprint = await fetchModuleBlueprint(moduleBlueprintId);
      const updateFormData = { ...mBlueprint }
      formData.setValues(updateFormData)
    } catch (e) {
      console.log(e)
      formData.setValues({})
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (moduleBlueprintId !== 'new') {
      getModuleBlueprint()
    } else {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleBlueprintId])

  const performSave = async () => {
    setIsSaving(true)
    try {
      const saveData = {
        ...formData.values
      }

      await updateModuleBlueprint(saveData);

      snackbar.newMessage({ 
        message: 'Successfully saved session template', 
        severity: 'success'
      })

      if (moduleBlueprintId === 'new') {
        // navigate(`/design/sessionTemplate?id=${response.moduleBlueprintId}`);
        navigate(`/design#session`);
      } else {
        // Need to set the assessment we started from to the newly edited assessment to be our new latest and greatest
        getModuleBlueprint();
      }
      
    } catch (e) {
      console.log(e)
    }
    setIsSaving(false)
  }

  const onSave = async () => {
    if (isValid()) {
      performSave()
    }
  }

  const hasEditEventTemplatePermissions = checkHasEditEventTemplatePermissions()
  if (!hasEditEventTemplatePermissions) {
    return <div></div>
  }

  return (
    <>
    {
      isLoading ?
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px'
      }}>
        <LoadingIcon />
      </div>
    :
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '20px'
    }}>
      <div style={{
        display: 'flex',
        marginBottom: '20px'
      }}>
        <div style={{
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          {moduleBlueprintId === 'new' ? 'New Session Template' : (formData.values.name || '-')}
        </div>
        <div style={{ flex: 1 }}>&nbsp;</div>
        <Button
          style={{
            display: 'inline-flex',
            width: '125px',
            padding: '8px 16px'
          }}
          // $colored={true}
          $disabled={isSaving || isReadOnly}
          onClick={() => {
            if (!isSaving && !isReadOnly) {
              onSave()
            }
          }}
        >
          <FaSave style={{ marginRight: '10px', color: '#0280c6' /* color: '#ffffff' */ }} />
          <span style={{ fontWeight: 'bold', color: '#565656' /* color: '#ffffff' */ }}>{'Save'}</span>
        </Button>
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          columnGap: '15px',
          rowGap: '15px',
        }}>
          <FormField
            fieldId='name'
            type='text'
            label='Name'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
          <FormField
            fieldId='description'
            type='textarea'
            label='Description'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
          <FormField
            fieldId='objective'
            type='textarea'
            label='Objective'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
          <FormField
            fieldId='image'
            type='text'
            label='Image'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
          <FormField
            fieldId='blueprintDocumentLink'
            type='text'
            label='Blueprint Document Link'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
          <FormField
            fieldId='slideDeckLink'
            type='text'
            label='Slide Deck Link'
            disabled={isReadOnly}
            style={{ flex: 1 }}
            formData={formData}
          />
        </div>
      </div>
    </div>
    }
    </>
  )
}